<template>
    <section class="custom-layout-record">
        <div class="layout">
            <div class="slides">
                <div v-for="(tabData , i) in layoutDetails.layoutComponents" :key="i">
                    <ds-text-button
                        :class="{'tab-selected': setTabSelected(tabData.name)}"
                        data-qa="contact-info"
                        @click="sendTabEvent(tabData.name, i)"
                    >
                        {{ tabData.name }}
                    </ds-text-button>
                </div>
            </div>

            <div class="search-save-button">
                <div v-if="enableSearchButton" class="search">
                    <ds-input-field
                        v-if="isSearchLabelChangeEnabled"
                        v-model="searchCriteria"
                        class="search-input-field"
                        :label="searchLabel"
                    >
                        <template #trailing>
                            <span
                                v-show="searchCriteria"
                                class="clear-icon"
                                @click="clearSearch"
                            >
                                <ds-icon name="x" />
                            </span>
                        </template>
                    </ds-input-field>
                    <ds-input-field
                        v-else
                        v-model="searchCriteria"
                        class="search-input-field"
                        label="Search contact info"
                    >
                        <template #trailing>
                            <span
                                v-show="searchCriteria"
                                class="clear-icon"
                                @click="clearSearch"
                            >
                                <ds-icon name="x" />
                            </span>
                        </template>
                    </ds-input-field>
                </div>

                <contact-layout-custom-info-header :id="id" :contact-details="contactDetails" />
            </div>
        </div>

        <div v-for="(tabDetails,headId) in layoutDetails.layoutComponents && layoutDetails.layoutComponents[tabId] && layoutDetails.layoutComponents[tabId].components" :key="headId">
            <h3 v-if="checkHeadersDisplay(tabDetails)" class="custom-fields-group fields-group-header">
                {{ tabDetails.name }}
            </h3>

            <div class="custom-fields-grid">
                <div v-for="(fields, fieldid) in tabDetails.components" :key="fieldid" class="custom-fields-container">
                    <contact-layout-custom-field-display
                        v-if="fields.contentType.includes('CUSTOM')"
                        :id="id"
                        :custom-fields="sendFieldData(fields.name)"
                        :header-details="tabDetails"
                        :search-criteria="searchCriteria"
                        :header-display="headerDetails"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FIRST_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.firstName"
                        :label="fields.name"
                        data-qa="systemField_FIRST_NAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('LAST_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.lastName"
                        :label="fields.name"
                        data-qa="systemField_LAST_NAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('JOB_TITLE', fields, tabDetails)"
                        v-model="contactRecordDetails.jobTitle"
                        :label="fields.name"
                        data-qa="systemField_JOB_TITLE"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('OWNER', fields, tabDetails)"
                        v-model="contactRecordDetails.owner"
                        :label="fields.name"
                        bind-value-only
                        :options="ownersDrop"
                        data-qa="systemField_OWNER"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('LEAD_SOURCE', fields, tabDetails)"
                        v-model="contactRecordDetails.leadSource"
                        :label="fields.name"
                        bind-value-only
                        :options="leadSourcesDrop"
                        data-qa="systemField_LEAD_SOURCE"
                        placeholder="Lead source"
                        searchable
                    />

                    <div v-if="fields.name === 'Company'" style="display: flex;">
                        <ds-multiselect
                            v-if="checkTypeAndDisplayField('COMPANY',fields, tabDetails)"
                            ref="companyMultiselect"
                            v-model="contactRecordDetails.companyID"
                            :label="fields.name"
                            :options="companies"
                            data-qa="systemField_COMPANY"
                            add-text="Add New Company"
                            allow-add
                            bind-value-only
                            name="companyDrop"
                            placeholder="Company"
                            searchable
                            show-search-icon
                            @add="addCompanyModal"
                        />
                        <span v-if="contactRecordDetails.companyID > 0 && checkTypeAndDisplayField('COMPANY',fields, tabDetails)" style="padding: 1px;">
                            <ds-tooltip position="top">
                                <template #default>
                                    <div>View Company</div>
                                </template>
                                <template #reference>
                                    <ds-icon-button name="external-link" @click="viewCompany" />
                                </template>
                            </ds-tooltip>
                        </span>
                    </div>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PHONE1', fields, tabDetails)"
                        v-model.trim="contactRecordDetails.phone1.number"
                        :label="fields.name"
                        data-qa="systemField_PHONE1"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('PHONE1_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.phone1.type"
                        :label="fields.name"
                        bind-value-only
                        :options="phoneTypeDrop"
                        data-qa="systemField_PHONE1_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PHONE2', fields, tabDetails)"
                        v-model.trim="contactRecordDetails.phone2.number"
                        :label="fields.name"
                        data-qa="systemField_PHONE2"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('PHONE2_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.phone2.type"
                        bind-value-only
                        :label="fields.name"
                        :options="phoneTypeDrop"
                        data-qa="systemField_PHONE2_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FAX1', fields, tabDetails)"
                        v-model="contactRecordDetails.fax1"
                        :label="fields.name"
                        data-qa="systemField_FAX1"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FAX1_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.fax1.type"
                        :label="fields.name"
                        data-qa="systemField_FAX1_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('EMAIL', fields, tabDetails)"
                        v-model="contactRecordDetails.email"
                        :label="fields.name"
                        data-qa="systemField_EMAIL"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('WEBSITE', fields, tabDetails)"
                        v-model="contactRecordDetails.website"
                        :label="fields.name"
                        data-qa="systemField_WEBSITE"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.website)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="webSite"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('TWITTER', fields, tabDetails)"
                        v-model="contactRecordDetails.twitter"
                        :label="fields.name"
                        data-qa="systemField_TWITTER"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.twitter)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="twitter"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FACEBOOK', fields, tabDetails)"
                        v-model="contactRecordDetails.facebook"
                        :label="fields.name"
                        data-qa="systemField_FACEBOOK"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.facebook)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="facebook"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('LINKEDIN', fields, tabDetails)"
                        v-model="contactRecordDetails.linkedin"
                        :label="fields.name"
                        data-qa="systemField_LINKEDIN"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.linkedin)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="linkedIn"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('INSTAGRAM', fields, tabDetails)"
                        v-model="contactRecordDetails.instragram"
                        :label="fields.name"
                        data-qa="systemField_INSTAGRAM"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.instragram)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="instagram"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('SNAP_CHAT', fields, tabDetails)"
                        v-model="contactRecordDetails.snapchat"
                        :label="fields.name"
                        data-qa="systemField_SNAP_CHAT"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.snapchat)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="snapchat"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('YOUTUBE', fields, tabDetails)"
                        v-model="contactRecordDetails.youtube"
                        :label="fields.name"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.youtube)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="youtube"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PINTEREST', fields, tabDetails)"
                        v-model="contactRecordDetails.pinterest"
                        :label="fields.name"
                        data-qa="systemField_PINTEREST"
                    >
                        <ds-icon
                            v-show="socialFieldEmptyCheck(contactRecordDetails.pinterest)"
                            slot="trailing"
                            class="external-look"
                            name="external-link"
                            @click.native.stop="pinterest"
                        />
                    </ds-input-field>

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('STREET_ADDRESS1', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.street1"
                        :label="fields.name"
                        data-qa="systemField_STREET_ADDRESS1"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('STREET_ADDRESS2', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.street2"
                        :label="fields.name"
                        data-qa="systemField_STREET_ADDRESS2"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('COUNTRY', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.countryCode"
                        :label="fields.name"
                        bind-value-only
                        :options="options.country"
                        data-qa="systemField_COUNTRY"
                        searchable
                        placeholder="Country"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('CITY', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.city"
                        :label="fields.name"
                        data-qa="systemField_CITY"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('STATE', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.state"
                        :label="fields.name"
                        data-qa="systemField_STATE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('POSTAL_CODE', fields, tabDetails)"
                        v-model="contactRecordDetails.billingAddress.postalCode"
                        :label="fields.name"
                        data-qa="systemField_POSTAL_CODE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ADDRESS2_STREET2', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.street2"
                        :label="fields.name"
                        data-qa="systemField_ADDRESS2_STREET2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ADDRESS2_STREET1', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.street1"
                        :label="fields.name"
                        data-qa="systemField_ADDRESS2_STREET1"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('COUNTRY2', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.countryCode"
                        :label="fields.name"
                        bind-value-only
                        :options="options.country"
                        data-qa="systemField_COUNTRY2"
                        searchable
                        placeholder="Country"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('CITY2', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.city"
                        :label="fields.name"
                        data-qa="systemField_CITY2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('STATE2', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.state"
                        :label="fields.name"
                        data-qa="systemField_STATE2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('POSTAL_CODE2', fields, tabDetails)"
                        v-model="contactRecordDetails.shippingAddress.postalCode"
                        :label="fields.name"
                        data-qa="systemField_POSTAL_CODE2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ADDRESS3_STREET1', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.street1"
                        :label="fields.name"
                        data-qa="systemField_ADDRESS3_STREET1"
                    />
                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ADDRESS3_STREET2', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.street2"
                        :label="fields.name"
                        data-qa="systemField_ADDRESS3_STREET2"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('COUNTRY3', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.countryCode"
                        :label="fields.name"
                        bind-value-only
                        :options="options.country"
                        data-qa="systemField_COUNTRY3"
                        searchable
                        placeholder="Country"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('CITY3', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.city"
                        :label="fields.name"
                        data-qa="systemField_CITY3"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('STATE3', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.state"
                        :label="fields.name"
                        data-qa="systemField_STATE3"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('POSTAL_CODE3', fields, tabDetails)"
                        v-model="contactRecordDetails.optionalAddress.postalCode"
                        :label="fields.name"
                        data-qa="systemField_POSTAL_CODE3"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ASSISTANT_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.assistantName"
                        :label="fields.name"
                        data-qa="systemField_ASSISTANT_NAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('ASSISTANT_PHONE', fields, tabDetails)"
                        v-model="contactRecordDetails.assistantPhone"
                        :label="fields.name"
                        data-qa="systemField_ASSISTANT_PHONE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('SSN', fields, tabDetails)"
                        v-model="contactRecordDetails.ssn"
                        :label="fields.name"
                        data-qa="systemField_SSN"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('SPOUSE_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.spouseName"
                        :label="fields.name"
                        data-qa="systemField_SPOUSE_NAME"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('TITLE', fields, tabDetails)"
                        v-model="contactRecordDetails.title"
                        :label="fields.name"
                        bind-value-only
                        :options="options.titles"
                        data-qa="systemField_TITLE"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('SUFFIX', fields, tabDetails)"
                        v-model="contactRecordDetails.suffix"
                        :label="fields.name"
                        bind-value-only
                        :options="options.suffixs"
                        data-qa="systemField_SUFFIX"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('MIDDLE_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.middleName"
                        :label="fields.name"
                        data-qa="systemField_MIDDLE_NAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('REFERRAL_CODE', fields, tabDetails)"
                        v-model="contactRecordDetails.referralCode"
                        :label="fields.name"
                        data-qa="systemField_REFERRAL_CODE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('NICKNAME', fields, tabDetails)"
                        v-model="contactRecordDetails.nickname"
                        :label="fields.name"
                        data-qa="systemField_NICKNAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PASSWORD', fields, tabDetails)"
                        v-model="contactRecordDetails.password"
                        type="password"
                        :label="fields.name"
                        data-qa="systemField_PASSWORD"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('USER_NAME', fields, tabDetails)"
                        v-model="contactRecordDetails.userName"
                        :label="fields.name"
                        data-qa="systemField_USER_NAME"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PHONE3', fields, tabDetails)"
                        v-model.trim="contactRecordDetails.phone3.number"
                        :label="fields.name"
                        data-qa="systemField_PHONE3"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('PHONE3_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.phone3.type"
                        bind-value-only
                        :label="fields.name"
                        :options="options.phoneTypes"
                        data-qa="systemField_PHONE3_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PHONE4', fields, tabDetails)"
                        v-model.trim="contactRecordDetails.phone4.number"
                        :label="fields.name"
                        data-qa="systemField_PHONE4"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('PHONE4_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.phone4.type"
                        bind-value-only
                        :label="fields.name"
                        :options="options.phoneTypes"
                        data-qa="systemField_PHONE4_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('PHONE5', fields, tabDetails)"
                        v-model.trim="contactRecordDetails.phone5.number"
                        :label="fields.name"
                        data-qa="systemField_PHONE5"
                    />

                    <ds-select-field
                        v-if="checkTypeAndDisplayField('PHONE5_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.phone5.type"
                        bind-value-only
                        :label="fields.name"
                        :options="options.phoneTypes"
                        data-qa="systemField_PHONE5_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FAX2', fields, tabDetails)"
                        v-model="contactRecordDetails.fax2"
                        :label="fields.name"
                        data-qa="systemField_FAX2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('FAX2_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.fax2.type"
                        bind-value-only
                        :label="fields.name"
                        data-qa="systemField_FAX2_TYPE"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('EMAIL_ADDRESS2', fields, tabDetails)"
                        v-model="contactRecordDetails.email2"
                        :label="fields.name"
                        data-qa="systemField_EMAIL_ADDRESS2"
                    />

                    <ds-input-field
                        v-if="checkTypeAndDisplayField('EMAIL_ADDRESS3', fields, tabDetails)"
                        v-model="contactRecordDetails.email3"
                        :label="fields.name"
                        data-qa="systemField_EMAIL_ADDRESS3"
                    />

                    <ds-date-picker
                        v-if="checkTypeAndDisplayField('ANNIVERSARY', fields, tabDetails)"
                        v-model="contactRecordDetails.anniversary"
                        :label="fields.name"
                        date-only
                        data-qa="systemField_ANNIVERSARY"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('CONTACT_TYPE', fields, tabDetails)"
                        v-model="contactRecordDetails.personType"
                        bind-value-only
                        :options="personType"
                        :label="fields.name"
                        data-qa="systemField_CONTACT_TYPE"
                        placeholder="Person Type"
                        searchable
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('LANGUAGE', fields, tabDetails)"
                        v-model="contactRecordDetails.language"
                        :options="options.languages"
                        bind-value-only
                        :label="fields.name"
                        data-qa="systemField_LANGUAGE"
                        searchable
                        placeholder="Language"
                    />

                    <ds-multiselect
                        v-if="checkTypeAndDisplayField('TIMEZONE', fields, tabDetails)"
                        v-model="contactRecordDetails.timeZone"
                        :options="options.timeZones"
                        bind-value-only
                        :label="fields.name"
                        data-qa="systemField_TIMEZONE"
                        searchable
                        placeholder="Timezone"
                    />

                    <ds-date-picker
                        v-if="checkTypeAndDisplayField('BIRTHDAY', fields, tabDetails)"
                        v-model="contactRecordDetails.birthday"
                        :label="fields.name"
                        date-only
                        data-qa="systemField_BIRTHDAY"
                    />
                </div>
            </div>

            <div v-if="isManageLayoutGroupingUpSystemFieldsEnabled" class="other-fields">
                <div v-for="(fields, fieldid) in tabDetails.components" :key="fieldid" class="custom-fields-container">
                    <ds-text-area-field
                        v-if="checkTypeAndDisplayField('PERSON_NOTES', fields, tabDetails)"
                        v-model="contactRecordDetails.notes"
                        :label="fields.name"
                        :maxlength="maxCharacter"
                        class="person-notes"
                    />

                    <div v-if="checkTypeAndDisplayField('ACCOUNT_SUMMARY_AND_LEADSCORE', fields, tabDetails)" class="profile-label slides">
                        <div class="section-header">
                            <h3>Account Summary &amp; Lead Score</h3>
                        </div>
                        <div class="account-summary">
                            <div class="summary">
                                <div class="account">
                                    Amt paid
                                </div>

                                <p class="paid">
                                    {{ detailsList.amountPaid }}
                                </p>
                            </div>

                            <div class="summary">
                                <div class="account">
                                    Bal due
                                </div>

                                <p class="due">
                                    {{ detailsList.billDue }}
                                </p>
                            </div>

                            <div class="summary">
                                <div class="account">
                                    <ds-text-button
                                        id="backToTop"
                                        class="account-invoice"
                                        dense
                                        data-qa="view-invoices"
                                        leading-icon="external-link"
                                        @click="viewInvoices"
                                    >
                                        Invoices
                                    </ds-text-button>
                                </div>
                            </div>

                            <div class="lead-score">
                                <div class="account">
                                    Lead Score
                                </div>

                                <span v-for="({ leadScore, i }) in leadScoreValue" :key="i">
                                    <ds-icon class="fire-icon" name="fire-fill" />
                                </span>

                                <span v-for="({ leadScore, i }) in (5 - leadScoreValue)" :key="i">
                                    <ds-icon class="fire-icon" name="fire" />
                                </span>

                                <span class="score">{{ leadScoreValue }}/5</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Company ref="companyModal" />
    </section>
</template>

<script>
import axios from 'axios';
import cloneDeep from 'lodash.clonedeep';
import Company from '../Company';
import ContactLayoutCustomFieldDisplay from './ContactLayoutCustomFieldDisplay';
import ContactLayoutCustomInfoHeader from '../ContactLayoutCustomInfoHeader';

export default {
    components: {
        ContactLayoutCustomFieldDisplay,
        ContactLayoutCustomInfoHeader,
        Company,
    },

    props: {
        id: [String, Number],
        contactLayoutDetails: Object,
    },

    data() {
        return {
            url: '/app/contact',
            searchCriteria: '',
            layoutDetails: [],
            selectedTab: 'ContactInfo',
            tabId: 0,
            contactDetails: {},
            maxCharacter: 70000,
            leadScoreValue: '',
            contactRecordDetails: {
                contactId: '',
                firstName: '',
                lastName: '',
                companyID: '',
                templateId: '',
                mailId: '',
                jobTitle: '',
                personType: '',
                leadSource: '',
                owner: '',
                notes: '',
                email: '',
                email2: '',
                email3: '',
                website: '',
                twitter: '',
                facebook: '',
                linkedin: '',
                instragram: '',
                snapchat: '',
                youtube: '',
                pinterest: '',
                phone1: {
                    number: '',
                    extension: '',
                    type: '',
                },
                phone2: {
                    number: '',
                    extension: '',
                    type: '',
                },
                phone3: {
                    number: '',
                    extension: '',
                    type: '',
                },
                phone4: {
                    number: '',
                    extension: '',
                    type: '',
                },
                phone5: {
                    number: '',
                    extension: '',
                    type: '',
                },

                fax1: '',
                fax2: '',
                billingAddress: {
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    postalCode: '',
                },
                shippingAddress: {
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    postalCode: '',
                },
                optionalAddress: {
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    postalCode: '',
                },
                language: '',
                timeZone: '',
                assistantName: '',
                assistantPhone: '',
                ssn: '',
                birthday: '',
                spouseName: '',
                anniversary: '',
                title: '',
                suffix: '',
                middleName: '',
                nickname: '',
                referralCode: '',
                userName: '',
                password: '',
            },
            layoutId: 0,
            options: {},
            companies: [],
            customFieldData: {},
            fieldData: {},
            headerFieldsData: {},
            headerDetails: {},
            enableSearchButton: true,
            searchLabel: 'Search Contact info',
            isSearchLabelChangeEnabled: false,
            featureFlagValues: [],
            limit: 0,
            maxLimit: 1000,
            offset: 0,
            isContactCompaniesLimitEnabled: false,
            isManageLayoutGroupingUpSystemFieldsEnabled: false,
            detailsList: {},
        };
    },

    beforeDestroy() {
        this.$root.$off('DEFAULT_CONTACT_LAYOUT_ID');
        this.$root.$off('DROPDOWN_LOADED');
        this.$root.$off('COMPANY_DETAILS');
        this.$root.$off('DISABLE_SAVE_BUTTON');
    },

    mounted() {
        this.$root.$on('DISABLE_SAVE_BUTTON', (data) => {
            this.enableSearchButton = data;
        });

        this.$root.$on('DEFAULT_CONTACT_LAYOUT_ID', (data) => {
            this.layoutId = data;
        });

        this.$root.$on('LAYOUTID_TAB', (data) => {
            this.tabId = 0;
            this.getLayoutDetailsById(data);
        });

        this.$root.$on('DROPDOWN_LOADED', (dropDowns) => {
            this.options = dropDowns;
        });
    },

    created() {
        this.getCustomFieldDataByContactId();
        this.companies.push({ label: 'None', value: '' });

        this.$root.$on('COMPANY_DETAILS', (newCompany) => {
            if (newCompany !== null) {
                this.companies.push({
                    label: newCompany.companyName,
                    value: Number(newCompany.id),
                });
                this.contactRecordDetails.companyID = Number(newCompany.id);
            }
        });

        this.load();
    },

    computed: {
        checkTypeAndDisplayField() {
            return (type, field, tabDetails) => {
                return field.contentType === type && this.displayField(field.name, tabDetails);
            };
        },

        concatHeader() {
            // appending header with id because to make header unique
            return (head, id) => {
                return `${head.replace(/\s+/g, '').toLowerCase()}_${id}`;
            };
        },

        checkHeadersDisplay() {
            return (headerObj) => {
                const headName = this.concatHeader(headerObj.name, headerObj.id);

                return this.checkField(headerObj.name) || this.fieldSearchHeaderDisplay(headName) || this.headerDetails[headName];
            };
        },

        displayField() {
            // searching with field names should return true if exist
            return (field, head) => {
                field = field?.replace(/\s+/g, '').toLowerCase();
                const header = this.concatHeader(head.name, head.id);

                return this.checkField(field) || this.headerDetails[header];
            };
        },

        fieldSearchHeaderDisplay() {
            // searching with field name should return header names ex: General information
            return (param) => {
                param = param.replace(/\s+/g, '').toLowerCase();
                const searchField = this.searchCriteria?.replace(/\s+/g, '');
                const headsToDisplay = Object.keys(this.headerFieldsData).filter((key) => {
                    return this.headerFieldsData[key].toString().replace(/\s+/g, '').toLowerCase().includes(searchField.toLowerCase());
                });

                return headsToDisplay.includes(param);
            };
        },

        checkField() {
            return (da) => {
                const searchField = this.searchCriteria?.replace(/\s+/g, '');

                Object.keys(this.headerDetails).forEach((key) => {
                    this.headerDetails[key] = key.split('_')[0].toLowerCase().includes(searchField.toLowerCase());

                    return this.headerDetails;
                });

                return da?.replace(/\s+/g, '').toLowerCase().includes(searchField.toLowerCase());
            };
        },

        personType() {
            return this.options.personType;
        },

        ownersDrop() {
            return this.options.owners;
        },

        countryDrop() {
            return this.options.country;
        },

        phoneTypeDrop() {
            return this.options.phoneTypes;
        },

        languageDrop() {
            return this.options.languages;
        },

        timeZonesDrop() {
            return this.options.timeZones;
        },

        suffixsDrop() {
            return this.options.suffixs;
        },

        titlesDrop() {
            return this.options.titles;
        },

        leadSourcesDrop() {
            if (!this.options.leadSources) {
                return [];
            }

            const cloneLeadSources = cloneDeep(this.options.leadSources);
            const leadSource = [{ label: 'None', value: 0 }];
            const leadSourceList = cloneLeadSources.sort((str1, str2) => {
                return str1.label.localeCompare(str2.label);
            });

            leadSource.push(...leadSourceList);

            return leadSource;
        },
    },


    methods: {
        clearSearch() {
            this.searchCriteria = '';
        },

        sendFieldData(field) {
            return this.customFieldData && this.customFieldData.find((sub) => sub.label === field);
        },

        socialFieldEmptyCheck(socialField) {
            return socialField !== '' && socialField !== null;
        },

        webSite() {
            window.open(`https://${this.contactRecordDetails.website}`);
        },

        facebook() {
            window.open(`https://www.facebook.com/${this.contactRecordDetails.facebook}`);
        },

        twitter() {
            window.open(`https://twitter.com/${this.contactRecordDetails.twitter}`);
        },

        youtube() {
            window.open(`http://www.youtube.com/${this.contactRecordDetails.youtube}`);
        },

        pinterest() {
            window.open(`https://www.pinterest.com/${this.contactRecordDetails.pinterest}`);
        },

        snapchat() {
            window.open(`https://www.snapchat.com/${this.contactRecordDetails.snapchat}`);
        },

        instagram() {
            window.open(`https://www.instagram.com/${this.contactRecordDetails.instragram}`);
        },

        linkedIn() {
            window.open(`https://www.linkedin.com/${this.contactRecordDetails.linkedin}`);
        },

        viewCompany() {
            window.open(`/Company/manageCompany.jsp?view=edit&ID=${this.contactRecordDetails.companyID}`);
        },

        viewInvoices() {
            window.open(`/Reports/searchTemplate.jsp?reportClass=AllSales&view=resultsPage&RunSearch=true&ContactId_DATA=${this.id}&Date_DATA=1-1-1970&Date_DATA2=${this.date}`);
        },

        async getCustomFieldDataByContactId() {
            const response = await axios.get(`/app/contact/layout/${this.id}`);

            this.contactDetails = response.data;
            this.customFieldData = response.data.customFields;
            this.contactRecordDetails = response.data.contactRecordDetails;
            this.getLayoutDetailsById(this.contactLayoutDetails);
            await this.getCompanies();
        },

        sendTabEvent(tabName, id) {
            this.tabId = id;
            this.$root.$emit('TAB_SELECTED', `from_Layout_$${tabName}`);
            this.selectedTab = tabName;
            this.changeSearchLabelName(tabName);
        },

        addCompanyModal() {
            this.$refs.companyModal.showModal();
        },

        changeSearchLabelName(tabName) {
            this.searchLabel = `Search ${tabName}`;
        },

        async getCompanies() {
            try {
                let url = '';

                if (this.isContactCompaniesLimitEnabled) {
                    url = `${this.url}/getCompanies?limit=${this.limit}&offset=${this.offset}`;
                } else {
                    url = `${this.url}/getCompanies?limit=${this.maxLimit}&offset=${this.offset}`;
                }
                const response = await axios.get(url);

                const companies = [{ label: 'None', value: Number(0) }];

                this.companies = Object.entries(response.data).map((entry) => {
                    companies.push({ label: entry[1], value: Number(entry[0]) });

                    return { label: entry[1], value: Number(entry[0]) };
                });
                this.companies = companies;
            } catch (error) {
                this.$error({ message: 'Unable to load Companies' });
            }
        },

        setTabSelected(tabName) {
            return this.selectedTab === tabName;
        },

        async getLayoutDetailsById(data) {
            this.layoutDetails = data;

            for (let i = 0; i < this.layoutDetails.layoutComponents.length; i++) {
                const layoutComponentName = this.layoutDetails.layoutComponents[i].name;

                if (layoutComponentName === 'Access privileges' || layoutComponentName === 'Follow-up-sequences') {
                    this.layoutDetails.layoutComponents.splice(i, 1);
                    i--;
                }

                if (layoutComponentName === 'Web profile') {
                    this.layoutDetails.layoutComponents.splice(i, 1);
                    i--;
                }
            }

            this.headerFieldsData = {};
            this.layoutDetails?.layoutComponents?.map((comp) => comp?.components?.map((head) => {
                // preparing map object, header with fields
                this.headerFieldsData[this.concatHeader(head?.name.replace(/\s+/g, '').toLowerCase(), head.id)] = head?.components?.map((fld) => fld.name);

                // initializing header map names with true
                this.headerDetails[this.concatHeader(head?.name.replace(/\s+/g, '').toLowerCase(), head.id)] = true;

                return head;
            }));

            if (this.layoutDetails.layoutComponents && this.layoutDetails.layoutComponents[0] !== undefined) {
                this.setTabSelected(this.layoutDetails.layoutComponents[0].name);
                this.sendTabEvent(this.layoutDetails.layoutComponents[0].name, 0);
            }
        },

        async load() {
            await this.getFeatureFlagValues();
            this.getContactRecordDetails();
            this.getCompanies();
        },

        async getContactRecordDetails() {
            const url = `/app/contact/${this.id}`;

            try {
                const response = await axios.get(url, {
                    headers: {
                        Accept: 'application/json',
                    },
                });

                this.detailsList = JSON.parse(JSON.stringify(response.data).replace(/:null/gi, ':""'));
                this.leadScoreValue = this.detailsList.leadScore;

                if (this.leadScoreValue !== 0) {
                    if (this.leadScoreValue <= 3) {
                        this.leadScoreValue = 2;
                    } else if (this.leadScoreValue <= 6) {
                        this.leadScoreValue = 4;
                    } else {
                        this.leadScoreValue = 5;
                    }
                }
            } catch (error) {
                this.$error({ message: 'error while loading Contact Details' });
            }
        },

        async getFeatureFlagValues() {
            try {
                const response = await axios.get('/app/contactLayout/getFeatureFlags');

                this.featureFlagValues = response.data;
                this.isSearchLabelChangeEnabled = this.featureFlagValues.isSearchLabelChangeEnabled;
                this.isContactCompaniesLimitEnabled = this.featureFlagValues.isContactCompaniesLimitEnabled;
                this.isManageLayoutGroupingUpSystemFieldsEnabled = this.featureFlagValues.isManageLayoutGroupingUpSystemFieldsEnabled;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    margin: $spacing-075 0;
    padding: 0  $spacing-200;
    height: 28px;
    display: inline-flex;
    align-items: center;
    font-size: small;
    color: $color-text;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: $color-gray-20;
    border: none;
    border-radius: 1.6rem;
    cursor: pointer;

    &:hover,
    &:active {
        color: $color-text;
        background-color: $color-white;
        box-shadow: $drop-shadow-z2;
    }
     &:focus {
         outline:0;
     }
}

.layout {
    display: flex;
    flex-direction: column;
}

.input-grid {
    --input-margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: $spacing-300;
}

.tab-content {
    padding: $spacing-200;
    display: flex;
    overflow-y: hidden;
}

.slides {
    display: flex;
    flex-flow: row wrap;
    @include padding-start($spacing-050);

    > div {
        @include margin-end($spacing-100);
    }
}

.fields-group-header {
    margin-bottom: $spacing-300;
}

.custom-fields-group {
    display: flex;
    flex-direction: column;
    border-top: 1px solid $color-gray-lighter;
    margin-top: $spacing-200;
    padding-top: $spacing-300;
}

.tab-selected {
    background-color: $color-white;
    box-shadow: $drop-shadow-z2;
}

.external-look {
    --icon-color: blue;
    --icon-size: 1rem;
    margin-top: 3px;
    cursor: pointer;
}

@media screen and ($small) {
    .record {
        margin: 0 ($spacing-300 * -1);
    }

    .slides {
        flex-flow: row nowrap;
        overflow-x: auto;
        padding: 0 $spacing-300;
    }

    .slides::-webkit-scrollbar {
        display: none;
    }
}

@media screen and (max-width: 1200px) {
    .input-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media screen and ($medium) {
    .slides {
        display: flex;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
}

.custom-fields-grid {
    --input-margin-bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: $spacing-300;
}

@media screen and (max-width: 1200px) {
    .custom-fields-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media screen and ($small) {
    .custom-fields-grid {
        grid-template-columns: 1fr;
    }
}

.custom-layout-record {
    width: 100%;
}

.custom-fields-container:empty {
    display: none;
}

.search-input-field {
    --input-margin-bottom: 0;
}

.search {
    width: px-to-rem(320px);
    --icon-color: #{$color-gray-600};
    margin-top: $spacing-200;
    justify-content: flex-start;
}

.clear-icon {
    --icon-color: #{$color-ink};
    cursor: pointer;
}

.search-save-button {
    justify-content: space-between;
    display: flex;
    margin-top: $spacing-200;
}

.person-notes {
    --input-margin-bottom: 0;
}

.other-fields {
    padding-top: $spacing-300;
}

.profile-label {
    padding: $spacing-300 0 $spacing-100;
}

.slides {
    display: flex;
    flex-flow: row wrap;
}

.account-summary {
    display: flex;
    align-items: center;

    > :not(:last-child) {
        @include margin-end($spacing-200);
    }
}

.summary {
    font-size: $font-size-xs;
    display: inline-block;
    color: $color-gray-90;
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $spacing-400;
    border-top: 1px solid $color-gray-30;
    padding-top: $spacing-300;
}

.account {
    background-color: $color-white;
    color: $color-gray-80;
}

.account-invoice {
    color: $color-blue-600;
    background-color: $color-white;
}

.paid {
    font-size: $font-size-md;
    margin-bottom: 0;
}

.due {
    font-size: $font-size-md;
    color: $color-red;
    margin-bottom: 0;
}

.lead-score {
    font-size: $font-size-xs;
    display: inline-block;
    color: $color-black;
}

.score {
    font-style: normal;
    font-size: $font-size-sm;
    padding: $spacing-100;
}
</style>
